import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { FormControl,  FormBuilder} from '@angular/forms';
import { secureValidator } from '../../validators/secure-validator';
import { FormConstants } from '../../../core/globals/form-constants';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['../../styles/form-input.scss', './search.component.scss']
})
export class SearchComponent implements OnInit {

  @Input() config: any;

  @Input() type = 'searchAndSelect';
  @Input() placeholder: string;
  @Input() activeOption: number;
  @Input() getCustomOptionValue: (arg0: any) => string;
  @Input() getCustomOptionLabel: (arg0: any) => string;
  @Input() fetchAsyncOptions: (arg0: string) => Observable<any[]>;
  @Input() customStyle: string;
@Input() configObject: any;
@Input() riderLimitReached: boolean;
  @Output() changeCallback = new EventEmitter();
  @Output() addRiderCallback = new EventEmitter();


  public canSearch: boolean;
  public canAdd: boolean;
  public isListShown = false;
  public selectOptions = [];
  private searchQuery: string;
  public displayValue: FormControl;
  public value: any;
  private optionsFetchThrottleTimer: any;
  private optionsFetchSubscription: any;
  public errorMessages = FormConstants.errorMessages;

  constructor(private formBuilder: FormBuilder, private elementRef: ElementRef) {}

  ngOnInit() {
    this.setOptions();
    this.displayValue = this.formBuilder.control('', [secureValidator]);
  }

  setDisplayValue(): void {
    if (!this.value) {
      return;
    }
    for (const option of this.selectOptions) {
      if (this.getOptionValue(option) === this.value) {
        this.displayValue.setValue(this.getOptionLabel(option));
        return;
      }
    }
    this.displayValue.setValue(this.value);
  }

  setValue(value: string) {
    this.value = value;
    if (this.changeCallback) {
      this.changeCallback.emit(this.value);
    }
  }

  onOptionClick(option: any): void {
    this.setValue(this.getOptionValue(option));
    this.hideList();
    this.displayValue.reset();
    this.searchQuery = '';
    this.fetchOptions();
  }

  addRider(){
    this.addRiderCallback.emit(true);
    this.isListShown = false;
  }

  getOptionValue(option: any): string {
    return typeof option === 'string' ? option : this.getCustomOptionValue(option);
  }

  getOptionLabel(option: any): string {
    return typeof option === 'string' ? option : this.getCustomOptionLabel(option);
  }

  setOptions = (): void => {
    switch (this.type) {
      case 'searchAndSelect':
        this.canAdd = false;
        this.placeholder = this.placeholder || 'Search & select';
        break;
      case 'searchOrAdd':
        this.canAdd = true;
        this.placeholder = this.placeholder || 'Search or enter';
        break;
      default: console.warn('Incorrect dropdown type', this.type);
    }
  }

  handleTriggerClick(e: Event) {
    this.isListShown ? this.hideList() : this.showList();
  }

  handleInputChange(event?: any) {
    this.searchQuery = this.displayValue.value;
    this.fetchOptions();
    if (this.canAdd) {
      this.setValue(this.getValueFromDisplayValue());
    }

    if (event && event.keyCode === 13 && typeof this.activeOption === 'number') {
      this.setValue(this.getOptionValue(this.selectOptions[this.activeOption]));
      this.hideList();
    } else if (event && event.keyCode === 13 && this.isListShown) {
      this.hideList();
    } else if (!event || event.keyCode !== 27) {
      this.showList();
    }
  }

  preventEnterKeyBehaviour(event) {
    // enter key triggers a click outside event by default
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  }

  setHighlightedOption(event) {
    if (event && event.keyCode === 40) {
      // down arrow key triggers a page scroll by default
      event.preventDefault();
      this.activeOption = (typeof this.activeOption === 'number' && this.activeOption < this.selectOptions.length - 1)
                            ? (this.activeOption + 1) : 0;
      this.scrollToActiveOption();
    } else if (event && event.keyCode === 38) {
      // up arrow key triggers a page scroll by default
      event.preventDefault();
      this.activeOption = (typeof this.activeOption === 'number' && this.activeOption > 0)
                            ? (this.activeOption - 1) : this.selectOptions.length - 1;
      this.scrollToActiveOption();
    } else if (event && (event.keyCode === 9 || event.keyCode === 27)) {
      this.hideList();
    }
  }

  scrollToActiveOption() {
    const parent = this.elementRef.nativeElement;
    parent.getElementsByClassName('select-option')[this.activeOption].scrollIntoView({block: 'nearest'});
  }

  getValueFromDisplayValue(): string {
    const displayValue = this.displayValue.value && this.displayValue.value.toLowerCase().trim();
    for (const option of this.selectOptions) {
      if (this.getOptionLabel(option).toLowerCase() === displayValue) {
        return this.getOptionValue(option);
      }
    }
    return this.canAdd ? this.displayValue.value :  '';
  }

  handleInputBlur() {
    if (!this.value) {
      this.setDisplayValue();
      this.handleInputChange();
    }
  }

  fetchOptions() {
    if (!this.searchQuery || this.searchQuery.length <= 2 || this.displayValue.errors) {
      setTimeout(() => {
        this.selectOptions = [];
      }, 100);
      if (this.optionsFetchThrottleTimer) {
        clearTimeout(this.optionsFetchThrottleTimer);
        this.optionsFetchThrottleTimer = null;
      }
      if (this.optionsFetchSubscription) {
        this.optionsFetchSubscription.unsubscribe();
      }
      return;
    }
    if (this.searchQuery.length > 2 && !this.displayValue.errors) {
      if (this.optionsFetchThrottleTimer) {
        return;
      }
      this.optionsFetchThrottleTimer = setTimeout(() => {
        if (this.optionsFetchSubscription) {
          this.optionsFetchSubscription.unsubscribe();
        }
        this.optionsFetchSubscription = this.fetchAsyncOptions(this.searchQuery).subscribe((result) => {
          this.selectOptions = result;
          this.optionsFetchSubscription = null;
        });
        clearTimeout(this.optionsFetchThrottleTimer);
        this.optionsFetchThrottleTimer = null;
      }, 300);
    }
  }

  checkInput(event){
    return ((event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 64 && event.charCode <= 90) || ((event.charCode >= 48 && event.charCode <= 57)) || (event.charCode == 32) || (event.charCode == 39)  || (event.charCode >= 44 && event.charCode <= 47 ));
  }
  validateInput(event) {
    const clipboardData = event.clipboardData || window.Clipboard;
    const pastedText = clipboardData.getData('text');
    const specialCharsRegex = /[!#$%^&*()?":{}|<>]/;
    if (specialCharsRegex.test(pastedText)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  showList() {
    this.isListShown = true;
  }

  hideList() {
    this.isListShown = false;
    this.activeOption = undefined;
  }
}
